import { render, staticRenderFns } from "./TwoLineBtn.vue?vue&type=template&id=56997864&scoped=true&"
import script from "./TwoLineBtn.vue?vue&type=script&lang=js&"
export * from "./TwoLineBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56997864",
  null
  
)

export default component.exports